/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorJwVideo from 'base/components/labrador/JwVideo';

export const DynamicLabradorJwVideo: typeof LabradorJwVideo = (props) => {
    return <ErrorBoundary><LabradorJwVideo {...props} /></ErrorBoundary>;
}
export type DynamicLabradorJwVideoProps = PropsFromComponent<typeof LabradorJwVideo>;
